import React, { useEffect, useState } from 'react';

const DateTimeStamp = ({realTimeData}) => {
    const [warningMessage, setWarningMessage] = useState("");
    const [color, setColor] = useState("bg-slate-200")

  useEffect(() => {
    if (realTimeData) {
      try{
        console.log(realTimeData.ManualIndicator)
        if (realTimeData.ManualIndicator === false){
            setWarningMessage("System is Operating in Automatic Mode")
            setColor("bg-green-300")
        }
        else if (realTimeData.ManualIndicator === true){
            setWarningMessage("System is Operating in Manual or is Inactive")
            setColor("bg-red-300")
        }
        else{
            setWarningMessage("Operation Mode Unavailable")
            setColor("bg-slate-200")
        }
      }
      catch(err){
        setWarningMessage("Operation Mode Unavailable")
        setColor("bg-slate-200")
      }
    }    
  }, [realTimeData]);

  return (
    <div className={"col-span-2 " + [color] + " lg:text-xl font-bold p-4 rounded-lg text-center text-gray-700 shadow-3xl"}>
        <span>{warningMessage}</span>
    </div>
  );
};

export default DateTimeStamp;
